





import { Vue, Component } from "vue-property-decorator";
import axios from 'axios'

@Component
export default class Crypt extends Vue {
// https://valtis.infosys.it/RestApi/valtis/valtis
// http://localhost:8181/
created(){
    axios.get("https://valtis.infosys.it/RestApi/valtis/valtis/crypt")
        .then(result =>{
            var results = result.data;
            results.forEach(function(element: any){
                if(element.Utente === element.Password){
                    axios.post("https://valtis.infosys.it/RestApi/valtis/valtis/update", {
                        params:{
                            utente: {
                                username: element.Utente,
                                password: element.Password
                            }
                        }
                    }).then((resp) =>{
                        console.log(resp)
                    }).catch(error =>{
                        console.log(error)
                    })
                }
            });
        })
}
}
